import { observer } from "@legendapp/state/react";
import { Suspense, useEffect } from "react";
import OverlayLoader from "../../components/ui/overlay-loader/OverlayLoader";
import PageError from "../../components/ui/page-error/PageError";
import { overlayState$, pageState$ } from "../../state";
import CategoryHeader from "./header/CategoryHeader";
import CategoryOverlay from "./overlay/CategoryOverlay";
import SubCategory from "./subcategory/Subcategory";

export interface ISearchState {
    searchState: string,
    setSearchState: any
}


export const Category = observer(() => {
    //todo add search state or clean it up

    useEffect(() => {
        return () => {
            pageState$.activeItem.data.set(undefined);
            pageState$.activeItem.title.set(undefined);
            overlayState$.activeItemId.set(null);
        }
    }, [pageState$.activeItem])


    const hasError = pageState$.errorMessage.get() !== '';
    if (hasError) {
        return (
            <>
                <CategoryHeader />

                <Suspense fallback={<OverlayLoader />}>
                    <PageError />
                </Suspense>
            </>
        )
    }

    return (
        <>
            <CategoryHeader />

            <SubCategory />

            <CategoryOverlay />
        </>
    )
});
